import { Component, HostListener, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map, shareReplay, take } from 'rxjs/operators';

import {
  HiringManagerSubmitModalComponent,
  HiringManagerSubmitModalData,
} from '@modules/assigns/components/hiring-manager-submit-modal/hiring-manager-submit-modal.component';
import { MojoBatchService } from 'mojo-batch';

@Component({
  selector: 'mojo-batch-operation-submit-hiring-manager-review',
  templateUrl: './batch-operation-submit-hiring-manager-review.component.html',
  styleUrls: ['./batch-operation-submit-hiring-manager-review.component.scss'],
})
export class BatchOperationSubmitHiringManagerReviewComponent {
  @Input() jobId: number;
  @Input() isNotDisabled = true;

  disabled$ = this.selectionManagerService.selection$.pipe(
    map((selection) => selection.length === 0),
    shareReplay(1),
  );

  constructor(private selectionManagerService: MojoBatchService, private dialog: MatDialog) {}

  @HostListener('click')
  click() {
    this.selectionManagerService.selection$.pipe(take(1)).subscribe((candidateIds: string[]) => {
      this.dialog.open<HiringManagerSubmitModalComponent, HiringManagerSubmitModalData>(
        HiringManagerSubmitModalComponent,
        {
          panelClass: 'medium-size-modal',
          disableClose: true,
          data: {
            headerText: `Submit ${candidateIds.length} candidates to Hiring Manager`,
            subheaderText: 'Share some highlights you see in those candidates',
            candidateIds: candidateIds.map(Number),
            jobId: this.jobId,
            isBatchOperation: true,
          },
        },
      );
    });
  }
}
